import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-unpivot",
  "use": "tamr-icon-unpivot-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"tamr-icon-unpivot\">\n  <circle cx=\"12.5\" cy=\"12.5\" r=\"12.5\" />\n  <path fill=\"#FFF\" d=\"M10.52 9.063l1.036 1.035-2.617 2.61h6.68v-7.29h1.46v8.75H8.94l2.616 2.61-1.035 1.035-4.37-4.375\" />\n  <path fill=\"#FFF\" d=\"M5 9h1.2v9H5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol